import { GET, POST, DELETE } from "../apiController";

const USER = "/user";
const ORG_USER_COURSE = `${USER}/usercourse`;
const ORG = "/org";

// ---------------------------------------------------------------------------
// 0. Public course details (no auth – e.g. public course page)
// ---------------------------------------------------------------------------

export const getPublicCourseDetails = (data) => {
  return POST(`${ORG}/public/courseDetails`, data);
};

// ---------------------------------------------------------------------------
// 1. Courses list – /user/courses (All courses | My courses)
// ---------------------------------------------------------------------------

export const allCourses = (data) => {
  return POST(`${ORG_USER_COURSE}/get_all_course`, data);
};

export const getRecommendedCourses = async (limit = 8) => {
  const endpoint = `${ORG_USER_COURSE}/get_recommended_courses?limit=${limit}`;
  try {
    const response = await GET(endpoint);
    const courses = response?.data?.recommendations || response?.recommendations || [];
    console.log('[Recommended Courses]', courses.map((c) => c.course_name || c.title));
    return response;
  } catch (error) {
    console.log('[Recommended Courses]', []);
    throw error;
  }
};

export const getPopularCategoryCourses = async ({ categoryLimit = 3, courseLimit = 4 } = {}) => {
  const endpoint = `${ORG_USER_COURSE}/get_popular_category_courses?category_limit=${categoryLimit}&course_limit=${courseLimit}`;
  try {
    const response = await GET(endpoint);
    const courses = response?.data?.courses || response?.courses || [];
    console.log('[Popular Courses]', courses.map((c) => c.course_name || c.title));
    return response;
  } catch (error) {
    console.log('[Popular Courses]', []);
    throw error;
  }
};

export const getRecommendationPreferences = () => {
  return GET(`${ORG_USER_COURSE}/get_recommendation_preferences`);
};

export const saveRecommendationPreferences = (data) => {
  return POST(`${ORG_USER_COURSE}/save_recommendation_preferences`, data);
};

export const skipRecommendationPreferences = () => {
  return POST(`${ORG_USER_COURSE}/skip_recommendation_preferences`, {});
};

export const getMyCourses = (data) => {
  return POST(`${ORG_USER_COURSE}/get_my_course`, data);
};

// ---------------------------------------------------------------------------
// 2. Course details – /user/courses/courseDetails/:id
// ---------------------------------------------------------------------------

export const getMetadataCourseDetails = (data) => {
  return POST(`${ORG_USER_COURSE}/get_course_details`, data);
};

export const verifyUserCourseAccess = (data) => {
  return POST(`${ORG_USER_COURSE}/verify_course_access`, data);
};

export const AddMyCourses = (data) => {
  return GET(`${ORG_USER_COURSE}/add_to_mycourse?course_id=${data.course_id}`);
};

export const checkCoursePurchase = (data) => {
  return POST(`${ORG_USER_COURSE}/check_course_purchase`, data);
};

export const getQuestionsAsCourseQuiz = (data) => {
  return POST(`${ORG_USER_COURSE}/get_questions`, data);
};

export const getVideoById = (data) => {
  return GET(`${ORG_USER_COURSE}/get_video_by_id`, data);
};

// ---------------------------------------------------------------------------
// 3. Watch course – /user/courses/WatchCourse/:id
// ---------------------------------------------------------------------------

// 3.1 Overview: video + progress (module list, recent video, completion %)
export const getModuleList = (data) => {
  return POST(`${ORG_USER_COURSE}/get_module_list`, data);
};

export const saveRecentVideo = (data) => {
  return POST(`${ORG_USER_COURSE}/save_recent_video`, data);
};

export const saveDocumentView = (data) => {
  return POST(`${ORG_USER_COURSE}/save_document_view`, data);
};

export const getCourseCompletePercentage = (course_id, video_id = null) => {
  return GET(`${ORG_USER_COURSE}/course_completion/${course_id}/${video_id}`);
};

export const trackRecommendationEvent = (data) => {
  return POST(`${ORG_USER_COURSE}/track_recommendation_event`, data);
};

// ---------------------------------------------------------------------------
// 3.2 Notes
// ---------------------------------------------------------------------------

export const getNotes = (video_id) => {
  return GET(`${ORG_USER_COURSE}/get_notes_details?video_id=${video_id}`);
};

export const getModuleNotes = (module_id) => {
  return GET(`${ORG_USER_COURSE}/get_module_notes?module_id=${module_id}`);
};

export const addNote = (data) => {
  return POST(`${ORG_USER_COURSE}/add_note`, data);
};

export const updateNote = (data) => {
  return POST(`${ORG_USER_COURSE}/edit_note`, data);
};

export const deleteNotes = (noteId) => {
  return DELETE(`${ORG_USER_COURSE}/delete_note/${noteId}`);
};

export const getAttachments = (video_id) => {
  return GET(`${ORG_USER_COURSE}/attachments/${video_id}`);
};

// ---------------------------------------------------------------------------
// 3.3 Comments
// ---------------------------------------------------------------------------


export const getComments = (video_id) => {
  return GET(`${ORG_USER_COURSE}/get_comments_details?video_id=${video_id}`);
};

export const addComment = (data) => {
  return POST(`${ORG_USER_COURSE}/add_comment`, data);
};

export const updateComment = (data) => {
  return POST(`${ORG_USER_COURSE}/update_comment`, data);
};

export const deleteComment = (comment_id) => {
  return DELETE(`${ORG_USER_COURSE}/delete_comment/${comment_id}`);
};

export const updateLike = (commentId) => {
  return POST(`${ORG_USER_COURSE}/update_like`, { commentId });
};

export const addReplyComment = (data) => {
  return POST(`${ORG_USER_COURSE}/add_reply_comment`, data);
};

export const getRepliesByCommentId = (data) => {
  return POST(`${ORG_USER_COURSE}/get_replies_by_comment_id`, data);
};

export const updateReplyComment = (data) => {
  return POST(`${ORG_USER_COURSE}/update_reply_comment`, data);
};

export const deleteReplyComment = (reply_id) => {
  return POST(`${ORG_USER_COURSE}/delete_reply_comment`, { reply_id });
};

export { getProfileComments } from "./profile.services";


// ---------------------------------------------------------------------------
// 3.4 Ratings
// ---------------------------------------------------------------------------

export const getCourseReviews = (course_id, video_id) => {
  const queryParams = video_id
    ? `course_id=${course_id}&video_id=${video_id}`
    : `course_id=${course_id}`;
  return GET(`${ORG_USER_COURSE}/get_course_reviews?${queryParams}`);
};

export const addCourseReview = (data) => {
  return POST(`${ORG_USER_COURSE}/add_course_review`, data);
};

export const editCourseReview = (data) => {
  return POST(`${ORG_USER_COURSE}/edit_course_review`, data);
};

export const deleteReview = (review_id) => {
  return DELETE(`${ORG_USER_COURSE}/delete_review/${review_id}`);
};


// ---------------------------------------------------------------------------
// 3.5 Assessment (quiz)
// ---------------------------------------------------------------------------


export const getCourseAssessment = (data) => {
  return POST(`${ORG_USER_COURSE}/get_course_assessment_by_assessment_id`, data);
};

export const startAdaptiveAssessmentAttempt = (data) => {
  return POST(`${ORG_USER_COURSE}/start-attempt`, data);
};

export const getAdaptiveAssessmentSummary = (assessmentId) => {
  return GET(`${ORG_USER_COURSE}/adaptive-summary/${assessmentId}`);
};

export const getAdaptiveAssessmentNextQuestion = (attemptId) => {
  return GET(`${ORG_USER_COURSE}/next-question/${attemptId}`);
};

export const submitAdaptiveAssessmentAnswer = (data) => {
  return POST(`${ORG_USER_COURSE}/submit-answer`, data);
};

export const finishAdaptiveAssessmentAttempt = (data) => {
  return POST(`${ORG_USER_COURSE}/finish`, data);
};

export const submitAssessmentWithResult = (data) => {
  return POST(`${ORG_USER_COURSE}/submit_assessment_with_result`, data);
};

export const getAssessmentResultsDetailed = (assessmentId) => {
  return GET(`${ORG_USER_COURSE}/get_assessment_results_detailed/${assessmentId}`);
};

// ---------------------------------------------------------------------------
// 3.6 Survey
// ---------------------------------------------------------------------------

export const getCourseSurvey = (data) => {
  return POST(`${ORG_USER_COURSE}/get_survey_questions`, data);
};

export const submitCourseSurvey = (data) => {
  return POST(`${ORG_USER_COURSE}/submit_survey_answers`, data);
};

// ---------------------------------------------------------------------------
// 4. Payment (course checkout – order flow)
// ---------------------------------------------------------------------------

export const processPayUPayment = (data) => {
  return POST(`${ORG_USER_COURSE}/process_payu_payment`, data);
};

export const getPointsCheckoutPreview = (course_id) => {
  return POST(`${ORG_USER_COURSE}/points_checkout_preview`, { course_id });
};
